import {
  // IconSelected,
  Select,
} from '@ui/src';
import { RealMonthlyVolumeTypes } from './types';

import cn from './aml.module.css';

const RealMonthlyVolume = ({
  title,
  value,
  // warning,
  corporate,
  list,
  onUpdateRange,
  disabled,
}: RealMonthlyVolumeTypes): React.JSX.Element => (
  <div
    className={`${cn.realMonthlyVolume} ${
      corporate ? cn.realMonthlyVolumeCorporate : ''
    }`}
  >
    <div className={cn.realMonthlyVolumeTitle}>{title}</div>
    <div className={cn.realMonthlyVolumeValue}>
      <Select
        list={list || []}
        name="value"
        value={value || ''}
        selectWrapperClassName={`${cn.expandableRowContentSelect} ${cn.disabledSelect} ${cn.monthlyVolumeSelector}`}
        onChange={(e) => onUpdateRange(e.target.value as string)}
        disabled={disabled}
        borderless
      />
    </div>
    {/* <div className={cn.monthlyVolumesRight}>
      {!warning && (
        <div className={cn.monthlyVolumeIcon}>
          <IconSelected
            width={21}
            height={14}
            className={cn.realMonthlyVolumeIcon}
          />
        </div>
      )}
      {warning && <div className={cn.realMonthlyVolumeWarning}>{warning}</div>}
    </div> */}
  </div>
);

export default RealMonthlyVolume;
